(() => {
  const SECTION_SELECTOR = "[data-gb-client-results]";
  const TRACK_SELECTOR = ".gb-client-results__cards";
  const MOBILE_QUERY = window.matchMedia("(max-width: 749px)");
  const INTERVAL_MS = 2600;

  const getStep = (track) => {
    const firstCard = track.querySelector(".gb-client-results__card");
    if (!firstCard) {
      return 0;
    }
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || "0");
    return firstCard.getBoundingClientRect().width + gap;
  };

  const bindSection = (section) => {
    if (!section || section.dataset.gbClientResultsBound === "true") {
      return;
    }

    const isSlider = section.classList.contains("gb-client-results__root--mobile-slider");
    const track = section.querySelector(TRACK_SELECTOR);
    if (!isSlider || !track) {
      section.dataset.gbClientResultsBound = "true";
      return;
    }

    let timer = null;

    const clearTimer = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const tick = () => {
      const step = getStep(track);
      if (!step) {
        return;
      }

      const maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - step * 0.5) {
        track.scrollTo({ left: 0, behavior: "auto" });
        return;
      }

      track.scrollBy({ left: step, behavior: "smooth" });
    };

    const startTimer = () => {
      clearTimer();
      if (!MOBILE_QUERY.matches) {
        return;
      }
      timer = window.setInterval(tick, INTERVAL_MS);
    };

    track.addEventListener("touchstart", clearTimer, { passive: true });
    track.addEventListener("touchend", startTimer, { passive: true });

    if (typeof MOBILE_QUERY.addEventListener === "function") {
      MOBILE_QUERY.addEventListener("change", startTimer);
    } else {
      MOBILE_QUERY.addListener(startTimer);
    }

    startTimer();
    section.dataset.gbClientResultsBound = "true";
  };

  const init = (root = document) => {
    root.querySelectorAll(SECTION_SELECTOR).forEach(bindSection);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
